import { orchestrator } from 'satcheljs';
import { forwardSurfaceEvent } from '../actions';
import { lazyOpenNotesEditor } from 'owa-calendar-notes-editor';
import EventScope from 'owa-service/lib/contract/EventScope';
import { forwardCalendarEventService } from 'owa-calendar-events-actions';
import EditorScenarios from 'owa-editor/lib/store/schema/EditorScenarios';
import { isSeriesInstance } from 'owa-calendar-event-capabilities';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { forwardingInstanceInfoMessage } from 'owa-locstrings/lib/strings/forwardinginstanceinfomessage.locstring.json';
import { forwardingMasterInfoMessage } from 'owa-locstrings/lib/strings/forwardingmasterinfomessage.locstring.json';
import { forwardingSingleEventInfoMessage } from 'owa-locstrings/lib/strings/forwardingsingleeventinfomessage.locstring.json';

orchestrator(forwardSurfaceEvent, actionMessage => {
    const { event, eventScope, openEventDetails } = actionMessage;

    eventScope == EventScope.AllInstancesInSeries
        ? lazyOpenNotesEditor.importAndExecute(event.SeriesMasterItemId.Id, {
              editorScenario: EditorScenarios.CalendarReadToForward,
              eventScope: EventScope.Default,
              onSend: (
                  eventScope: EventScope,
                  notes: string,
                  proposedTime: any,
                  sendResponse: boolean,
                  forwardees: AttendeeType[]
              ) => {
                  forwardees.length > 0 &&
                      forwardCalendarEventService(event.ItemId, forwardees, notes, eventScope);
              },
              titleText: loc(forwardingMasterInfoMessage),
              iconName: ControlIcons.ForwardEvent,
              showNotifyToggle: false,
              sendResponse: true,
              forwardees: [],
          })
        : lazyOpenNotesEditor.importAndExecute(event.ItemId.Id, {
              editorScenario: EditorScenarios.CalendarReadToForward,
              eventScope: EventScope.Default,
              onSend: (
                  eventScope: EventScope,
                  notes: string,
                  proposedTime: any,
                  sendResponse: boolean,
                  forwardees: AttendeeType[]
              ) => {
                  forwardees.length > 0 &&
                      forwardCalendarEventService(event.ItemId, forwardees, notes, eventScope);
              },
              titleText: isSeriesInstance(event)
                  ? loc(forwardingInstanceInfoMessage)
                  : loc(forwardingSingleEventInfoMessage),
              iconName: ControlIcons.ForwardEvent,
              showNotifyToggle: false,
              sendResponse: true,
              forwardees: [],
          });
    openEventDetails(
        actionMessage.eventScope == EventScope.AllInstancesInSeries
            ? event.SeriesMasterItemId
            : event.ItemId
    );
});
